<template>
	<div class="vote">
		<section class="flex-r flex-ctr head">
			<van-image class="head-banner" :src="GE.banner" />
			<van-image class="head-banner-bottom" :src="GE.bannerBottom" />
		</section>
		<section class="flex-c wrap light-bg time-wrap">
			<van-image class="timing flex-self-ctr" :src="GE.timing" />
			<p class="flex-self-ctr pad">礼品发放：2020/1/17-2/28</p>
			<div class="time-text flex-self-ctr">
				<ul class="flex-r flex-btw">
					<li class="center share">
						<p>投稿征集</p>
						<p class="time-text-time">2019/10/14-12/14</p>
					</li>
					<li class="center share">
						<p>初赛筛选</p>
						<p class="time-text-time">2019/12/14-12/27</p>
					</li>
					<li class="center share">
						<p>决赛投票</p>
						<p class="time-text-time">2019/12/27-2020/1/17</p>
					</li>
				</ul>
				<div class="process">
					<van-image class="" :src="GE.processing" />
				</div>
			</div>
		</section>
		<section class="flex-c wrap" v-if="!mobile">
			<div class="intro flex-c flex-self-ctr">
				<van-image class="" :src="GE.introduce" />
				<span class="center intro-text">你是一名有情怀的科研极客吗？<br /> 你是一个披着科研外衣的段子手吗？<br />你还在为寻找实习机会而烦恼吗？<br />你还在苦于自己满身才华却无处施展吗？<br />......<br />想实习，没机会，找不到怎么办？ <br />想要的炫酷产品，买不起怎么办？ <br />快来参加由GEHC生命科学部和生物谷联合推出的实验室消耗品征文大赛吧！<br />赚世界 500 强企业的实习经历，拿奖品，秀才华！一篇征文帮你实现！</span>
			</div>
		</section>
		<section class="flex-c wrap" v-if="mobile">
			<div class="intro flex-c flex-self-ctr m-width">
				<van-image class="intro-bg" :src="GE.introduce" />
				<span class="center">你是一名有情怀的科研极客吗？<br /> 你是一个披着科研外衣的段子手吗？<br />你还在为寻找实习机会而烦恼吗？<br />你还在苦于自己满身才华却无处施展吗？<br />......<br />想实习，没机会，找不到怎么办？ <br />想要的炫酷产品，买不起怎么办？ <br />快来参加由GEHC生命科学部和生物谷联合推出的<br />实验室消耗品征文大赛吧！<br />赚世界 500 强企业的实习经历，拿奖品，秀才华！<br />一篇征文帮你实现！</span>
			</div>
		</section>
		<!-- <section class="flex-c wrap light-bg ms-box-shadow">
			<van-image class="zhengwen flex-self-ctr" :src="GE.zhengwen" />
			<div class="flex-self-ctr flex-r flex-ctr rule-img">
				<van-image class="rule-content" :src="r" v-for="(r, index) in GE.rule" :key="index" />
			</div>
		</section>
		<section class="flex-c wrap">
			<div class="center flex-self-ctr rule-text">
				<p><span v-if="mobile" class="circle">·</span>字数300字(Word或PDF格式)，两张以上图片，排版美观，条理清晰-尽显你的才华！</p>
				<p class="space"></p>
				<p><span v-if="mobile" class="circle">·</span>征文题材不限，内容包括成功经验分享、Trouble Shooting、实验心得、文献综述等。</p>
				<p class="space"></p>
				<p><span v-if="mobile" class="circle">·</span>征文内容需包含以下任一款/多款产品：（点击文章最后图片，下载资料）</p>
				<p><span class="ico">①</span>GEHC 蛋白电泳免疫印迹系列产品；</p>
				<p><span class="ico">②</span>GEHC 核酸电泳免疫印迹系列产品；</p>
				<p class="space"></p>
				<p><span v-if="mobile" class="circle">·</span>作者对文章的原创性负责；稿件一经采用，作者确认其创造的任何知识及与之相关的使用权利应归GEHC所有，GEHC将与作者签署必要的文件，将此类权利进行合法转让</p>
				<p class="space"></p>
				<p><span v-if="mobile" class="circle">·</span>投稿标题：【GE and ME】征文大赛+姓名+电话+单位。</p>
				<p><span v-if="mobile" class="circle">·</span>投稿邮箱：xiaoming.zhao@ge.com</p>
				<p><span v-if="mobile" class="circle">·</span>答疑邮箱：chunchao.li@ge.com</p>
			</div>
		</section> -->
		<section class="flex-c wrap light-bg ms-box-shadow">
			<van-image class="jiangpin flex-self-ctr" :src="GE.jiangpin" />
			<div class="flex-self-ctr flex-r flex-ctr flex-w gift-wrap">
				<div v-for="(item, index) in GE.gift" :key="index" :class="['gift-box','center',index === 0?'gif-box-index':'']">
					<van-image class="gift" :src="item.url" />
					<p class="gift-text">{{ item.text }}</p>
					<p class="gift-text gifts">{{ item.txt }}</p>
					<p :class="['gift-name',index === GE.gift.length -1 ?'name-box':'']">
						<template v-for="(child,key) in item.name">
							<span :class="index === GE.gift.length -1 ? 'gift-name-span-half':'gift-name-span'" :key="key">{{child}}</span>
						</template>
					</p>
				</div>
			</div>
			<div class="gift-info flex-self-ctr">
				<p><span class="circle">·</span>名单按姓名拼音首字母排序。</p>
				<p class="space"></p>
				<p><span class="circle">·</span>所有投稿人员均有机会成为 GEHC 生命科学部特邀写手。</p>
				<p class="space"></p>
				<p><span class="circle">·</span>以上奖品均由生物谷提供并于2020年2月3日开始安排发放，图片仅供参考，具体以实物为准</p>
			</div>
		</section>
		<!-- <section class="flex-c wrap">
            <van-image class="pingshen flex-self-ctr"
                       :src="GE.pingshen" />
            <div class="assess flex-self-ctr">· 所有入选文章将在生物谷网站公开，采用集赞的形式评选出 20 位入选者，之后进入第二轮评审，将隐去投稿人姓名+电话+单位等个人信息<br />我们将邀请产品部和市场部相关人员组成评审团 队，从：1）与我们 2020 年产品策略匹配度； 2）体现策略产品； 3）观点有说服力三个维度<br />通过内部投票的方式评选出一二三等奖</div>
        </section> -->
		<section class="flex-c wrap light-bg ms-box-shadow">
			<van-image class="toupiao flex-self-ctr" :src="GE.toupiao" />

			<div v-if="candidateListMsg.data && candidateListMsg.data.length" class="vote-wrap flex-w flex-ctr flex-self-ctr">
				<div class="wrap-item flex-c" v-for="(item, index) in candidateListMsg.data" :key="index">
					<van-image class="head-pic" lazy-load fit="cover" :src="item.img_url" @click="goCandidate(item.id)" />
					<div class="wrap-item-title" @click="goCandidate(item.id)">{{item.title}}</div>
					<p class="vote-author">姓名：{{item.author||'无'}}</p>
					<p class="vote-company">单位：{{item.company||'无'}}</p>
					<!-- <p class="vote-text">
						<span>投票数</span>
						<span class="vote-num">{{ item.votes }} </span>
					</p> -->
					<!-- <van-button type="primary" :loading="submitItem == item.id" loading-text="投票中" @click="vote_click(item)">投票</van-button> -->
				</div>
			</div>
			<div v-else class="vote-state flex-self-ctr">
				征集中...
			</div>
		</section>
		<footer class="flex-c footer wrap">
			<van-image class="qita flex-self-ctr" @click="checkPdf" :src="GE.qita" />
			<div class="flex-w flex-ctr">
				<van-image class="footer-pic flex-self-ctr" v-for="(p,p_index) in GE.otherProduct" :key="p_index" @click="checkPdf" :src="p" />
			</div>
		</footer>
	</div>
</template>

<script type="text/javascript">
	import { mapState } from 'vuex'
	import api from './../fetch/vote.js'
	export default {
		data () {
			return {
				submitItem: '',
				GE: {
					banner: require('@/assets/banner.png'),
					bannerBottom: require('@/assets/banner-bottom.png'),
					processing: '',
					timing: require('@/assets/title-bg.png'),
					zhengwen: require('@/assets/title-bg.png'),
					jiangpin: require('@/assets/title-bg.png'),
					pingshen: require('@/assets/title-bg.png'),
					toupiao: require('@/assets/title-bg.png'),
					qita: require('@/assets/title-bg.png'),
					introduce: require('@/assets/intro2.png'),
					rule: [require('@/assets/rule01.png'), require('@/assets/rule02.png')],
					gift: [{
						url: require('@/assets/gift1.png'),
						text: '一等奖一名',
						txt: 'Kindle Paperwhite4',
						key: "one",
						name: []
					}, {
						url: require('@/assets/gift2.png'),
						text: '二等奖三名',
						txt: '铁三角耳机',
						key: "two",
						name: []
					}, {
						url: require('@/assets/gift3.png'),
						text: '三等奖五名',
						txt: 'Casio G-Shock手表',
						key: "three",
						name: []
					}, {
						url: require('@/assets/gift4.png'),
						text: '初赛入选奖二十名',
						txt: '电动牙刷',
						key: "four",
						name: []
					}],
					otherProduct: [require('@/assets/other01.png'), require('@/assets/other02.png'), require('@/assets/other03.png'), require('@/assets/other04.png')],
					mobile: false,
					period: 1
				}
			}
		},
		created () {
			var sUserAgent = navigator.userAgent.toLowerCase();
			var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
			var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
			var bIsMidp = sUserAgent.match(/midp/i) == "midp";
			var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
			var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
			var bIsAndroid = sUserAgent.match(/android/i) == "android";
			var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
			var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
			if (!(bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM)) {
				this.mobile = false;
			} else {
				this.mobile = true;
			}
			let currentTime = Number(new Date().getTime());
			let processSecond = Number(new Date('2019/12/14').getTime());
			let processThird = Number(new Date('2019/12/27').getTime());
			switch (true) {
				case currentTime > processThird:
					this.GE.period = 2;
					this.GE.processing = require('@/assets/processing3.png');
					break;
				case currentTime > processSecond:
					this.GE.period = 2;
					this.GE.processing = require('@/assets/processing2.png');
					break;
				default:
					this.GE.processing = require('@/assets/processing.png');
			}
		},
		mounted () {
			this.init();
			this.wx_share({});
		},
		methods: {
			init () {
				this.submitItem = '';
				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					loadingType: 'spinner'
				});
				this.$store.dispatch('getCandidateListApi').then(() => {
					this.$toast.clear();
					api.prize_list().then(resp => {
						if (resp.data && resp.data.data) {
							this.GE.gift.forEach(item => {
								item.name = resp.data.data[item.key] || []
							})
						}
					}).catch(e => {
						// eslint-disable-next-line no-console
						console.log(e)
					})
				}).catch(() => {
					this.$toast.clear();
				});
			},
			checkPdf () {
				// let url = 'http://7n.m-visitor.medsci.cn/ge/pdfge.pdf';
				let url = 'http://7n.m-visitor.medsci.cn/ge/ge.png';
				this.$router.push({ path: '/pdf', query: { url: url } });
			},
			goCandidate (id) {
				this.$router.push({ path: '/candidate', query: { id: id } });
			},
			vote_click (item) {
				this.$toast.loading({
					message: '投票中...',
					forbidClick: true,
					loadingType: 'spinner'
				});
				this.submitItem = item.id;
				this.$store.dispatch('voteApi', item.id).then(() => {
					// this.init();
					this.$toast.clear();
					item.votes++;
					this.$toast.success({
						duration: 500, // 持续展示 toast
						forbidClick: true,
						message: '投票成功'
					});
					this.submitItem = "";
				}).catch(e => {
					this.$toast.clear();
					this.submitItem = '';
					// eslint-disable-next-line no-console
					console.log(e)
				})
			}
		},
		computed: mapState({
			candidateListMsg: state => state.Vote.candidateListMsg
		})
	}
</script>

<style lang="scss" scpoped>
	.vote::before {
		content: "";
		position: absolute;
		left: 0;
		width: 2rem;
		top: 0;
		bottom: 0;
		background: url("../assets/left-bac.png") repeat-y;
		background-size: 100% auto;
		overflow: hidden;
		z-index: 1;
	}
	.gif-box-index {
		width: 100% !important;
	}
	.vote::after {
		content: "";
		position: absolute;
		right: 0;
		width: 2rem;
		top: 0;
		bottom: 0;
		background: url("../assets/right-bac.png") repeat-y;
		background-size: 100% auto;
		overflow: hidden;
		z-index: 1;
	}
	.gift-name-span {
		display: inline-block;
		width: 80%;
		padding: 5px 0;
	}
	.gift-name-span-half {
		display: inline-block;
		width: 25%;
		padding: 5px 0;
	}
	.name-box {
		width: 200%;
		transform: translateX(-25%);
	}
	.vote {
		width: 100%;
		// height: 100Vh;
		// overflow-y: scroll;
		position: relative;
		color: #fff;
		background-color: #005296;
		font-size: 20px;
		&-author {
			overflow: hidden;
			margin-top: 5px;
			text-overflow: ellipsis;
			white-space: nowrap;
			width: 3.5rem;
		}
		&-company {
			overflow: hidden;
			margin-top: 5px;
			text-overflow: ellipsis;
			white-space: nowrap;
			width: 3.5rem;
		}
		.head {
			position: relative;
			overflow: hidden;
			.head-banner {
				min-width: 16rem;
			}
			.head-banner-bottom {
				width: 100%;
				min-width: 300px;
				position: absolute;
				bottom: 0;
				transform: translateY(17.89%);
			}
		}
		.space {
			height: 18px;
		}
		.wrap {
			padding-top: 45px;
			padding-bottom: 40px;
			position: relative;
			&-item {
				position: relative;
				&-title {
					position: absolute;
					left: 24%;
					top: 2rem;
					font-size: 0.31rem;
					text-align: center;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 3;
					overflow: hidden;
					width: 52%;
					cursor: pointer;
				}
			}
			&.time-wrap {
				.timing {
					width: 157px;
					margin-bottom: 50px;
				}
				.pad {
					padding-bottom: 20px;
				}
				.timing:before {
					content: "活动时间";
					width: 100%;
					text-align: center;
					position: absolute;
					left: 50%;
					top: 50%;
					transform: translate(-50%, -50%);
				}
				.time-text {
					width: 864px;
					color: #fff;
					max-width: 90%;
					.process {
						width: 100%;
						padding-top: 20px;
					}
				}
			}
			.zhengwen {
				width: 173px;
				margin-bottom: 50px;
			}
			.zhengwen:before {
				content: "征文投稿规则";
				width: 100%;
				text-align: center;
				position: absolute;
				left: 50%;
				top: 50%;
				transform: translate(-50%, -50%);
			}
			.jiangpin {
				width: 157px;
				margin-bottom: 50px;
			}
			.jiangpin:before {
				content: "获奖名单";
				width: 100%;
				text-align: center;
				position: absolute;
				left: 50%;
				top: 50%;
				transform: translate(-50%, -50%);
			}
			.pingshen {
				width: 157px;
				margin-bottom: 50px;
			}
			.pingshen:before {
				content: "评审规则";
				width: 100%;
				text-align: center;
				position: absolute;
				left: 50%;
				top: 50%;
				transform: translate(-50%, -50%);
			}
			.toupiao {
				width: 157px;
				margin-bottom: 50px;
			}
			.toupiao:before {
				content: "WB征文赏析";
				width: 100%;
				text-align: center;
				position: absolute;
				left: 50%;
				top: 50%;
				transform: translate(-50%, -50%);
			}
			.qita {
				width: 173px;
				margin-bottom: 50px;
			}
			.qita:before {
				content: "产品目录下载";
				color: #005296;
				width: 100%;
				text-align: center;
				position: absolute;
				left: 50%;
				top: 50%;
				transform: translate(-50%, -50%);
			}
			.intro {
				max-width: 90%;
				padding: 0.35rem 0;
				position: relative;
				&.m-width {
					width: 675px;
				}
				.intro-bg {
					width: 100%;
					height: 100%;
					position: absolute;
					left: 0;
					top: 0;
				}
				.intro-text {
					width: 88%;
					padding: 0 20px;
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translateY(-50%) translateX(-50%);
				}
			}
			.rule-img {
				width: 600px;
				max-width: 90%;
				.rule-content {
					width: 308px;
					margin: 0 30px;
				}
			}
			.rule-text {
				line-height: 34px;
				max-width: 90%;
			}
			.gift-wrap {
				// width: 1000px;
				max-width: 90%;
				margin-bottom: 20px;
				padding-top: 5%;
				.gift-box {
					width: 40%;
					margin: 0 30px;
					margin-bottom: 10px;
					margin-top: -5%;
					.gift-text {
						padding-top: 5px;
						&.gifts {
							width: 120%;
							transform: translateX(-10%);
						}
					}
				}
			}
			.gift-info {
				max-width: 90%;
			}
			.assess {
				max-width: 90%;
			}
		}
		.light-bg {
			background-color: #0d5b9b;
		}
		.ms-box-shadow:before {
			content: "";
			background: radial-gradient(
				#005296,
				#0d5b9b,
				#5fc9f5,
				#0d5b9b,
				#005296
			);
			height: 2px;
			width: 80%;
			position: absolute;
			top: 0;
			transform: translate(-50%, 0);
			left: 50%;
		}
		.ms-box-shadow:after {
			content: "";
			background: radial-gradient(
				#005296,
				#0d5b9b,
				#5fc9f5,
				#0d5b9b,
				#005296
			);
			height: 2px;
			width: 80%;
			position: absolute;
			bottom: 0;
			transform: translate(-50%, 0);
			left: 50%;
		}
		.vote-state {
			font-size: 26px;
			padding: 40px;
			color: #fff;
		}
		.text-content {
			color: #fff;
			text-align: center;
		}
		.vote-wrap {
			max-width: 1400px;
			z-index: 2;
			.wrap-item {
				padding: 10px;
				margin: 0 10px 50px 10px;
				background-color: #0d5b9b;
				.head-pic {
					width: 300px;
					height: 300px;
					cursor: pointer;
				}
				.vote-text {
					text-align: center;
					padding: 20px 0;
					.vote-num {
						margin-left: 10px;
						display: inline-block;
						min-width: 80px;
						// text-align: center;
						border-radius: 16px;
						background-color: #5fc9f5;
					}
				}
			}
		}
		.ico {
			// transform: translateY(-1px);
			display: inline-block;
		}
		p {
			position: relative;
			padding-left: 20px;
		}
		.circle {
			font-size: 30px;
			// transform: scale(3) translateY(3px);
			display: inline-block;
			position: absolute;
			left: 0;
			top: -10%;
		}
		.footer {
			background-color: #fff;
			z-index: 222;
			.footer-pic {
				width: 158px;
				margin: 0 50px;
			}
		}
	}
	@media screen and (max-width: 500px) {
		.vote .wrap .rule-text {
			text-align: left;
			font-size: 0.3rem;
			line-height: 0.5rem;
		}
		.vote .wrap .intro.m-width .center {
			font-size: 0.3rem;
			line-height: 0.5rem;
		}
		.vote {
			font-size: 0.3rem;
		}
		.vote .wrap.time-wrap .timing:before,
		.vote .wrap .jiangpin:before,
		.vote .wrap .pingshen:before,
		.vote .wrap .toupiao:before,
		.vote .wrap .qita:before,
		.vote .wrap .zhengwen:before {
			font-size: 0.3rem;
		}
		.vote::before {
			width: 0.8rem;
		}
		.vote::after {
			width: 0.8rem;
		}
		.time-text-time {
			font-size: 12px;
			margin-top: 2px;
		}
	}
</style>


